import { createFileRoute } from '@tanstack/react-router'
import { EmplacementForm } from '@features/stock/components/EmplacementForm'
import { usePermissions } from '@lib/hooks/usePermissions'
import { requirePermission } from '@lib/permissions/guards'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'

export const Route = createFileRoute('/_app/stock/emplacements/create')({
  beforeLoad: ({ context }) => {
    requirePermission(PERMISSIONS.STOCK.EMPLACEMENTS.CREATE, context)
  },
  component: CreateEmplacementComponent,
})

function CreateEmplacementComponent() {
  const { canCreate } = usePermissions()
  
  if (!canCreate('stock.emplacements.create')) {
    return <div className="p-6">Accès non autorisé</div>
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Nouvel emplacement</h1>
      <EmplacementForm />
    </div>
  )
}
